import { NOTIFICATION } from "../enums/Notification";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import { IAdminNotification } from "../types/Notification";
import { IRequestArgs, ListResponseNotificationsData } from "../types/requests";

function getAdminNotifications({ queryParams }: IRequestArgs) {
  const query = {
    sort: {
      createdAt: "DESC",
    },
    limit: queryParams?.pagination?.limit || 10,
    page: queryParams?.pagination?.page || 1,
  };

  return request<ListResponseNotificationsData<IAdminNotification>>({
    method: ERequestMethods.GET,
    url: NOTIFICATION.LIST,
    params: query,
  });
}

function readNotification(id: string) {
  return request({
    method: ERequestMethods.PUT,
    url: NOTIFICATION.READ(id),
  });
}

function readAllNotifications() {
  return request({
    method: ERequestMethods.PUT,
    url: NOTIFICATION.READ_ALL,
  });
}

function deleteNotification(id: string) {
  return request({
    method: ERequestMethods.DELETE,
    url: NOTIFICATION.DELETE(id),
  });
}

const NotificationRepository = Object.freeze({
  getAdminNotifications,
  readNotification,
  readAllNotifications,
  deleteNotification,
});

export default NotificationRepository;
